import { CREATE_DESIGN, GET_DESIGN, DESIGN_REQUEST, DELETE_DESIGN, UPDATE_DESIGN, DESIGN_REQUEST_FAILURE } from "../types";


const initialState = {
    designs: [],
    loading: false,
    error: null,
  };

  const designReducer = (state = initialState, action) => {
    switch (action.type) {
      case DESIGN_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_DESIGN: {
        return {
          ...state,
          designs: [...action.payload],
          loading: false,
          error: null
        }
      }
      case CREATE_DESIGN:
        return {
          ...state,
          designs: [action.payload, ...state.designs],
          loading: false,
          error: null
        };
      case UPDATE_DESIGN:
        const designsData = state.designs.slice(0);
        const uIndex = designsData.findIndex((data) => data.id === action.payload.id);
        designsData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          designs: [ ...designsData ],
          loading: false,
          error: null
        };
      case DELETE_DESIGN:
        const designs = state.designs?.slice(0);
        const index = designs.findIndex((data) => data.id === action.id);
        if (index > -1) {
            designs.splice(index, 1);
        }
        return {
          ...state,
          designs: [...designs],
          loading: false,
          error: null
        }
      case DESIGN_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };

  export default designReducer